import TicketShowDesk from './components/ticket-show-desk/TicketShowDesk.vue';
import TicketIndexBoard from './components/tickets-index/TicketIndexBoard.vue';

export default function registerTicketManagerApVueComponents(app) {
    app.component('ticket-show-desk', TicketShowDesk);
    app.component('ticket-index-board', TicketIndexBoard);
}
